module.exports = __webpack_public_path__ + "img/polygon.0964382b.svg";